import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import CalendarAppResource from './CalendarAppResource';
import CalendarEventAppResource from './CalendarEventAppResource';
import ChannelAppResource from './ChannelAppResource';
import FileAppResource from './FileAppResource';
import StageTypeAppResource from './StageTypeAppResource';
import StageWorkspaceMemberAppResource from './StageWorkspaceMemberAppResource';
import WildAppResource from './WildAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

class StageAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Stage';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'stages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'closedAt',
            'workspaceUuid',
            'stageTypeUuid',
            'workspace',
            'stageType',
            'members',
            'channelPropertyInstances',
            'channels',
            'calendars',
            'calendarEvents',
            'files',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            stageType: StageTypeAppResource,
            members: StageWorkspaceMemberAppResource,
            channelPropertyInstances: WildAppResource,
            channels: ChannelAppResource,
            calendars: CalendarAppResource,
            calendarEvents: CalendarEventAppResource,
            files: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspace_uuid',
            stageType: 'stage_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            stageTypeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default StageAppResource;
